import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { INQUIRY_TYPE, FileUploadService, UPLOAD_TYPE, CommonCode, CodeService } from '../../../shared';
import {
  InquiryCreateDto,
  ATTACHMENT_REASON_TYPE,
  FileAttachmentDto,
  Product,
  Inquiry,
  INQUIRY_REFERENCE_TYPE,
} from '../../../dto';
import { InquiryService, GaService } from '../../../services';
import { BaseComponent } from '../../../core';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomDialogComponent } from '../../resp/_component/custom-dialog/custom-dialog.component';
import { TPipe } from '../../../common/pipes/t.pipe';
@Component({
  selector: 'app-inquiry',
  templateUrl: './inquiry.component.html',
  styleUrls: ['./inquiry.component.scss'],
})
export class InquiryComponent extends BaseComponent implements OnInit, OnChanges {
  isShowInquiryModal: boolean;

  @Input()
  product: Product;

  @Input()
  type: INQUIRY_TYPE | any;

  @Input()
  referenceOrderNumber?: number;

  @Input()
  referenceProductId?: string | number;

  @Input()
  isRequestProduct?: boolean;

  form: FormGroup;
  inquiryTypes: CommonCode[];
  attachments: FileAttachmentDto[] = [];

  // tslint:disable-next-line: no-output-on-prefix
  @Output()
  onChangeInquiryList = new EventEmitter<Inquiry>();

  constructor(
    private formBuilder: FormBuilder,
    private inquiryService: InquiryService,
    private fileUploadService: FileUploadService,
    private codeService: CodeService,
    private gaService: GaService,
    private t: TPipe
  ) {
    super();
    this.initForm();
  }

  ngOnInit() {
    this.inquiryTypes = this.codeService.getCommonCodes('INQUIRY_TYPE');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isRequestProduct) {
      this.isRequestProduct = changes.isRequestProduct.currentValue;
      this.init();
    }
    if (changes.type) {
      this.form.get('inquiryType').patchValue(changes.type.currentValue);
    }
  }

  initForm() {
    this.form = this.formBuilder.group({
      inquiryType: [this.type, Validators.required],
      subject: ['', Validators.required],
      contents: ['', Validators.required],
    });
    this.init();
  }

  init() {
    this.attachments = [];
    this.errors = {};
    if (this.isRequestProduct) {
      const subject = this.t.transform('BUTTON.REQUEST_SUPPLY');
      const contents = this.t.transform('INQUIRY.REQUEST_CONTENTS');
      this.form.get('subject').patchValue(subject);
      this.form.get('contents').patchValue(contents);
    }
  }

  public open() {
    this.isShowInquiryModal = true;
  }

  /**
   * inquiry upload: notice bucket type name
   */
  async onUpload(files: FileList) {
    if (files.length === 0) {
      return;
    }
    const attachments = await this.fileUploadService.upload(UPLOAD_TYPE.INQUIRY_ATTACHMENTS, files);
    const succ = attachments.filter(
      (fileAttachment) => fileAttachment.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS
    );
    this.attachments.push(...succ);
    if (attachments.length !== succ.length) {
      const dialog = this._openDialog({
        message: this.i18n.t('DIALOG.INQUIRY.SIZE_OVER'),
        close: () => {
          dialog.close();
        },
      });
    }
  }

  onSubmit() {
    const inquiryCreate: InquiryCreateDto = this.form.value;
    inquiryCreate.attachments = this.attachments;
    if (this.referenceOrderNumber) {
      inquiryCreate.referenceType = INQUIRY_REFERENCE_TYPE.PURCHASE_ORDER;
      inquiryCreate.referenceId = this.referenceOrderNumber;
    } else if (this.referenceProductId) {
      inquiryCreate.referenceType = INQUIRY_REFERENCE_TYPE.PRODUCT;
      inquiryCreate.referenceId = this.referenceProductId;
    }

    if (this.isValid(this.form, 'form')) {
      const dialog = this._openDialog({
        message: this.i18n.t('DIALOG.INQUIRY.REGISTER'),
        close: (result: any) => {
          dialog.close();
          this.inquiryService.sendInquiry(inquiryCreate).subscribe(
            (inquiry) => {
              try {
                this.gaService.MOJI_Inquiry(inquiry);
              } catch (err) {}

              const successDialog = this._openDialog({
                message: this.i18n.t('DIALOG.INQUIRY.SUCCESS'),
                close: () => {
                  this.closeInquiryModal(successDialog);
                  this.onChangeInquiryList.emit();
                },
              });
            },
            (error) => {
              this.errors.form = error;
            }
          );
        },
        cancel: () => {
          dialog.close();
        },
      });
    }
  }

  onDeleteAttachment(index: number) {
    this.attachments.splice(index, 1);
  }

  onCloseInquiryModal() {
    const dialog = this._openDialog({
      message: this.i18n.t('DIALOG.INQUIRY.CLOSE'),
      close: () => {
        this.closeInquiryModal(dialog);
      },
      cancel: () => {
        dialog.close();
      },
    });
  }

  private closeInquiryModal(dialog: MatDialogRef<CustomDialogComponent>) {
    this.initForm();
    dialog.close();
    this.isShowInquiryModal = false;
  }
}
